/**
 * search-lot-form.js starts
 * Created by mac on 05.10.2018.
 */
var searchLot = {
	formWrapper: 'lot-identity-search',
	form: 'search-lot-form',
	resultWrapper: 'lot-identity-results',
	templateId: 'lot-results-tpl',
	searchInputId: 'lotId',
	outTime: 400,
	inTime: 500,
	defaultStyles: {
		transform: 'translateX(-100%)',
		opacity: 0
	},
	toggleBlocks: function (show, hide) {
		var d = this.defaultStyles;
		var showAnime = anime({
			targets: show,
			translateX: 0,
			opacity: 1,
			duration: 550,
			easing: 'easeOutQuint',
			autoplay: false
		});
		if (hide) {
			var hideAnime = anime({
				targets: hide,
				translateX: '100%',
				opacity: 0,
				duration: 450,
				easing: 'easeInExpo',
			});
			hideAnime.complete = function () {
				hide.style.display = 'none';
				hide.style.transform = d.transform;
				hide.style.opacity = d.opacity;
				if (show) {
					show.style.display = 'block';
					showAnime.play();
				}
			};
		}
	},
	drawResult: function (data) {
		if (data === undefined) return false;
		var resultWrapper = document.getElementById(this.resultWrapper),
			formWrapper = document.getElementById(searchLot.formWrapper);
		if (typeof data === 'object') {
			var _resultsTpl = ' <div class="lot-info" style="transform: translateX(-100%); opacity: 0; display: none;">' +
				//'          <h4 class="lot-id">Лот '+data.lotId+'</h4>' +
				'          <h3 class="lot-title">' + data.lotTitle + '</h3>' + '          <p class="lot-description">' + data.lotDescr + '</p>' + '          <ul class="list-inline lot-actions">' + '            <li>' + '              <a href="' + data.lotUrl + '" class="btn btn-green btn-sm">Перейти к лоту</a>' + '            </li>' + '            <li>' + '              <button class="btn btn-gray btn-sm search-repeat-btn">Проверить другой лот</button>' + '            </li>' + '          </ul>' + '        </div>';
			$(resultWrapper)
				.html($(_resultsTpl));
			searchLot.toggleBlocks(resultWrapper.querySelector('.lot-info'), formWrapper);
		}
	},
	drawResultList: function (data) {
		console.log(123, data)
		if (data === undefined) return false;
		var formWrapper = document.getElementById(searchLot.formWrapper);
		var resultWrapper = formWrapper.querySelector('.variants')
		resultWrapper.addEventListener("click", function () {
			event.stopPropagation()
		})
		document.addEventListener("click", function () {
			resultWrapper.classList.remove("show")
		})
		resultWrapper.innerHTML = ""
		if (data && typeof data === "object") {
			data.forEach(function (elem) {
				let item = document.createElement('div');
				let a = document.createElement('a')
				item.classList.add('variant')
				item.append(a)
				a.setAttribute("href", elem.lotUrl)
				a.innerText = elem.lotTitle
				resultWrapper.append(item)
				resultWrapper.classList.add("show")
			});
		}
	},
	resetForm: function (formwrapper) {
		if (formwrapper) {
			var lotInput = document.getElementById(this.searchInputId);
			lotInput.value = '';
		}
	},
	showError: function (err) {
		if (err !== undefined && typeof err === 'object') {
			var form = document.getElementById(this.form);
			$(form)
				.popover({
					title: err.title,
					content: err.content,
					placement: 'top',
				});
			$(form)
				.popover('show');
			setTimeout(function () {
				$(form)
					.popover('dispose');
				// searchLot.resetForm(form);
			}, 3500);
		}
	}
};
$(function () {
	let searchInput = document.querySelector(`#${searchLot.formWrapper} #lotId`)
	let form = document.querySelector(`#${searchLot.form}`)

	function searchQuery() {
		console.log(searchInput.value)
		if (searchInput.value.match(/^[0-9\/]*$/g)) {} else {
			var $f = $(form),
				f_url = '/ajax/search_by_name.php',
				f_data = $f.serialize();
			$.ajax({
				url: f_url,
				method: "POST",
				data: f_data,
				success: function (res) {
					if (res) {
						var result = res;
						if (result.success == true) {
							searchLot.drawResultList(result.lot);
						} else {
							searchLot.showError(result.error);
						}
					}
				}
			});
		}
	}
	if (searchInput) {
		searchInput.addEventListener("input", searchQuery)
		searchInput.addEventListener("focus", searchQuery)
	}
	$('#search-lot-form')
		.on('submit', function (e) {
			e.preventDefault();
			e.currentTarget.ico.value = e.currentTarget.ico.value.trim();
			let text = e.currentTarget.ico.value;
			if (text.match(/^[0-9\/]*$/g)) {
				var $f = $(e.currentTarget),
					f_url = $f.attr('action'),
					f_data = $f.serialize();
				$.ajax({
					url: f_url,
					method: "POST",
					data: f_data,
					success: function (res) {
						if (res) {
							var result = res;
							if (result.success == true) {
								searchLot.drawResult(result.lot);
							} else {
								searchLot.showError(result.error);
							}
						}
					}
				});
			} else {
				document.location.href = `/catalog/?q=${text}`
			}
		});
	$(document)
		.on('click', '.search-repeat-btn', function (e) {
			var form = document.getElementById(searchLot.formWrapper),
				results = document.getElementById(searchLot.resultWrapper)
				.querySelector('.lot-info');
			searchLot.resetForm(form);
			searchLot.toggleBlocks(form, results);
			e.preventDefault();
		});
});
/* search-lot-form.js ends */
